import { Button } from "./Button"
import "../components/HeroSection.css";
import { Link } from "react-router-dom"

export default function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-bg-shape">
        <svg width="300" height="300" viewBox="0 0 300 300" fill="none">
          <circle cx="150" cy="150" r="140" stroke="currentColor" strokeWidth="2" />
          <path
            d="M150 100 L180 170 L120 170 Z"
            stroke="currentColor"
            strokeWidth="2"
            fill="currentColor"
            opacity="0.3"
          />
        </svg>
      </div>

      <div className="hero-container">
        <div className="hero-grid">
          <div className="hero-content">
            <h1 className="hero-heading">
              Advanced <span className="highlight">Healthcare Solutions</span> for Better Tomorrow
            </h1>
            <p className="hero-description">
              Discover innovative pharmaceutical products and treatments backed by cutting-edge research and
              development. Trusted by healthcare professionals.
            </p>
            <div className="hero-buttons">
              <Button className="btn-hero-primary">
                
                <a href="/#products" className="nav-link text-white">
             Explore Products</a> 
              </Button>
              <Button variant="outline" className="">
                <a href="/about" className="nav-link">
           View More
          </a>
              </Button>
            </div>
          </div>

          <div className="hero-image-wrapper">
            <img
              src="/pharmaceutical-laboratory-modern-medical-research-.jpg"
              alt="Pharmaceutical laboratory research"
              className="hero-image"
            />
            <div className="hero-overlay"></div>
          </div>
        </div>
      </div>
    </section>
  )
}

